var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 4.5,
    fill: "#007AFF",
    fillOpacity: 0.05,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1458 31.0602L29.583 34.5615L28.1829 33.1882C27.7601 32.7734 27.0738 32.7734 26.651 33.1882C26.2282 33.6029 26.2282 34.2759 26.651 34.6907L28.8206 36.8186C29.0285 37.0294 29.3058 37.1314 29.583 37.1314C29.8603 37.1314 30.1376 37.0294 30.3524 36.8186L34.6846 32.5695C35.1074 32.1548 35.1074 31.4817 34.6846 31.067C34.2618 30.6523 33.5686 30.6455 33.1458 31.0602Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1458 39.5585L29.583 43.0598L28.1829 41.6865C27.7601 41.2717 27.0738 41.2717 26.651 41.6865C26.2282 42.1012 26.2282 42.7742 26.651 43.189L28.8206 45.3101C29.0285 45.5141 29.3058 45.6229 29.583 45.6229C29.8603 45.6229 30.1376 45.5209 30.3524 45.3101L34.6846 41.061C35.1074 40.6463 35.1074 39.9732 34.6846 39.5585C34.2618 39.1438 33.5686 39.1438 33.1458 39.5585Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1592 33.936C37.1592 34.5207 37.6444 34.9966 38.2405 34.9966H42.5726C43.1688 34.9966 43.654 34.5207 43.654 33.936C43.654 33.3513 43.1688 32.8754 42.5726 32.8754H38.2405C37.6444 32.8754 37.1592 33.3513 37.1592 33.936Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5726 41.3737H38.2405C37.6444 41.3737 37.1592 41.8496 37.1592 42.4343C37.1592 43.019 37.6444 43.4949 38.2405 43.4949H42.5726C43.1688 43.4949 43.654 43.019 43.654 42.4343C43.654 41.8496 43.1688 41.3737 42.5726 41.3737Z",
    fill: "#007AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8235 22.2491H41.4913V21.1886C41.4913 20.6039 41.0061 20.128 40.41 20.128H38.0602C37.6097 18.8906 36.4106 18 34.9965 18C33.5825 18 32.3764 18.8906 31.9328 20.128H29.583C28.9869 20.128 28.5017 20.6039 28.5017 21.1886V22.2491H24.1696C22.9773 22.2491 22 23.201 22 24.3771V49.872C22 51.0414 22.9704 52 24.1696 52H45.8304C47.0227 52 48 51.0482 48 49.872V24.3771C47.9861 23.2078 47.0157 22.2491 45.8235 22.2491ZM30.6574 22.2491H32.827C33.4231 22.2491 33.9083 21.7732 33.9083 21.1886C33.9083 20.6039 34.3935 20.128 34.9896 20.128C35.5857 20.128 36.0709 20.6039 36.0709 21.1886C36.0709 21.7732 36.5561 22.2491 37.1522 22.2491H39.3218V24.3771H30.6574V22.2491ZM45.8235 49.872H24.1626V24.3771H28.4948V25.4377C28.4948 26.0224 28.98 26.4983 29.5761 26.4983H40.41C41.0061 26.4983 41.4913 26.0224 41.4913 25.4377V24.3771H45.8235V49.872Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/Survey.08110d2c7f02e07c6f2e05b21828b3b3.svg";
export { ForwardRef as ReactComponent };